import { useCallback, useId, useLayoutEffect, useSyncExternalStore } from "react";

/** Les fenêtres flottantes restent entre ce niveau et le menu contextuel du mémo (z-index 10). */
const BASE_LAYER = 2;

let order = [];
const listeners = new Set();

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function snapshot() {
  return order;
}

function update(next) {
  order = next;
  listeners.forEach((listener) => listener());
}

function raise(id) {
  if (order[order.length - 1] === id) return;
  update([...order.filter((item) => item !== id), id]);
}

function drop(id) {
  if (!order.includes(id)) return;
  update(order.filter((item) => item !== id));
}

export function useFloatingWindowLayer(open) {
  const id = useId();
  const current = useSyncExternalStore(subscribe, snapshot, snapshot);

  useLayoutEffect(() => {
    if (!open) return undefined;
    raise(id);
    return () => drop(id);
  }, [id, open]);

  const bringToFront = useCallback(() => raise(id), [id]);
  return { zIndex: BASE_LAYER + Math.max(0, current.indexOf(id)), bringToFront };
}
